import { CreditCard, Ticket } from "lucide-react";

export function Paywall({ plans, paying, onSubscribe, voucherCode, setVoucherCode, redeeming, onRedeem, yourLC, isStudent }) {
  return (
    <div className="nb-card p-8 mb-6 bg-white text-center max-w-2xl mx-auto" data-testid="parent-paywall">
      <div className="w-14 h-14 mx-auto rounded-xl border-2 border-zinc-900 bg-[#FDE68A] flex items-center justify-center shadow-[3px_3px_0px_0px_#18181B]">
        <CreditCard className="w-7 h-7" />
      </div>
      <h2 className="font-display font-black text-2xl mt-4">Unlock {yourLC} timetable</h2>
      <p className="text-zinc-500 mt-2 text-sm leading-relaxed">
        Pick a plan to unlock the full timetable builder, editable day layout and daily notes.
        {!isStudent && " Extra children are £5/year each, or £20 each on the 6-year plan."}
      </p>
      <div className={`mt-6 grid gap-4 ${plans.length > 1 ? "sm:grid-cols-2" : ""} max-w-lg mx-auto`}>
        {plans.map((p) => (
          <div key={p.id} className="rounded-xl border-2 border-zinc-900 p-5 bg-[#FDFBF7] shadow-[4px_4px_0px_0px_#18181B]" data-testid={`paywall-plan-${p.id}`}>
            <h3 className="font-display font-bold">{p.name}</h3>
            <div className="mt-2">
              <span className="font-display font-black text-3xl">£{Number(p.price_gbp).toFixed(2)}</span>
              <span className="font-bold text-sm text-zinc-600">
                {p.mode === "one_time" ? ` one-off · ${p.duration_years || 6} years` : " / year"}
              </span>
            </div>
            <p className="text-xs text-zinc-500 font-semibold mt-2">
              {p.mode === "one_time" ? "Covers the whole of secondary school — pay once, done." : "Renews yearly. Cancel anytime."}
            </p>
            <button onClick={() => onSubscribe(p)} disabled={!!paying} data-testid={`paywall-subscribe-${p.id}`}
              className="nb-btn w-full bg-[#1E3A8A] text-white px-4 py-2.5 mt-4 text-sm">
              {paying === p.id ? "Redirecting…" : "Pay with Stripe"}
            </button>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t-2 border-zinc-100">
        <p className="nb-label">Have a voucher code?</p>
        <div className="mt-2 flex gap-2 max-w-sm mx-auto">
          <input className="nb-input flex-1 uppercase tracking-widest text-center" data-testid="voucher-code-input" placeholder="TIMELY-XXXXXXXX"
            value={voucherCode} onChange={(e) => setVoucherCode(e.target.value.toUpperCase())} maxLength={30} />
          <button onClick={onRedeem} disabled={redeeming} data-testid="voucher-redeem-btn" className="nb-btn bg-[#A7E4D3] px-4 py-2 text-sm shrink-0">
            <Ticket className="w-4 h-4" /> {redeeming ? "Checking…" : "Redeem"}
          </button>
        </div>
      </div>
      <p className="text-xs text-zinc-400 mt-4">Secure checkout by Stripe. Prices exclude VAT — the exact total is shown at checkout.</p>
    </div>
  );
}
